import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import propTypes from 'prop-types';
import { useSelector } from 'react-redux';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    main: {
      paddingTop: '72px',
    },
    title: {
      fontSize: theme.sizes.md.t3,
    },
  }));
};

function WithHeader(props) {
  const { title, Icon, children } = props;
  const label = props.label;

  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();

  // redux
  const labelsConfiguration = useSelector((state) => state.app.labelsConfiguration);
  return (
    <Grid className={classes.main} display="flex" justifyContent="center" container spacing={0}>
      <Grid item xs={12} sm={10}>
        <Grid item sm={12}>
          <Box py={2}>
            <Box pb={2} display="flex" alignItems="center">
              <Box pr={1}>{Icon}</Box>
              <Typography className={classes.title}>{title}</Typography>
            </Box>
            {label &&
              labelsConfiguration &&
              labelsConfiguration[label] &&
              labelsConfiguration[label]
                .replace(/\\n/g, '\n')
                .split('\n')
                .map((line, firstIndex) => {
                  return line ? (
                    <Typography key={firstIndex}>
                      {line.split('*').map((e, secondIndex) => {
                        return secondIndex % 2 === 0 ? (
                          <span key={secondIndex}>{e}</span>
                        ) : (
                          <b key={secondIndex}>{e}</b>
                        );
                      })}
                    </Typography>
                  ) : (
                    <br key={firstIndex} />
                  );
                })}
          </Box>
        </Grid>
        {children}
      </Grid>
    </Grid>
  );
}

const Props = {
  label: propTypes.string,
  title: propTypes.string,
  children: propTypes.node,
  Icon: propTypes.node,
};

WithHeader.propTypes = Props;

export default WithHeader;
